
<div class="guide_breascrumbs_padding">
  <ng-container *ngFor="let nav of breadcrumbs$ | async">
    <a class="guide_breascrumbs" [routerLink]="[nav.route]">{{ nav.title }}</a><i class="fas fa-angle-right"></i>
  </ng-container>
</div>

